import { useEffect, useState } from "react";
import axios from "axios";
import GuruLayout from "../../components/layout/GuruLayout";
import { toast } from "react-toastify";

export default function RekapPresensi() {
  const token = sessionStorage.getItem("token");

  const [mapelList, setMapelList] = useState([]);
  const [kelasList, setKelasList] = useState([]);
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    id_mapel: "",
    id_kelas: "",
    tipe: "harian",
    tanggal: "",
    start: "",
    end: "",
    bulan: "",
  });

  useEffect(() => {
    axios.get("https://backend.smpn1kamal.sch.id/api/datamapel", { headers: { Authorization: `Bearer ${token}` } })
         .then((res) => setMapelList(res.data));
    axios.get("https://backend.smpn1kamal.sch.id/api/kelas",     { headers: { Authorization: `Bearer ${token}` } })
         .then((res) => setKelasList(res.data));
  }, [token]);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await axios.get("https://backend.smpn1kamal.sch.id/api/presensi/rekap", {
        params: form,
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data);
    } catch {
      toast.error("Gagal load data");
    } finally {
      setLoading(false);
    }
  };

  const downloadFile = async (url, filename) => {
    try {
      const res = await axios.get(url, {
        params: form,
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(new Blob([res.data]));
      link.download = filename;
      link.click();
    } catch {
      toast.error(`Gagal download ${filename}`);
    }
  };

  const toKey = (raw) => (raw ? String(raw).split("T")[0] : "");

  const buildPivot = () => {
    const tglSet = new Set();
    data.forEach((r) => tglSet.add(toKey(r.tanggal)));
    const tanggalList = Array.from(tglSet).sort();

    const siswaMap = new Map();
    data.forEach((r) => {
      if (!siswaMap.has(r.no_absen))
        siswaMap.set(r.no_absen, { no_absen: r.no_absen, nisn: r.nisn, nama_lengkap: r.nama_lengkap });
    });
    const siswaList = Array.from(siswaMap.values())
      .sort((a, b) => Number(a.no_absen) - Number(b.no_absen));

    const pivot = {};
    data.forEach((r) => {
      if (!pivot[r.no_absen]) pivot[r.no_absen] = {};
      pivot[r.no_absen][toKey(r.tanggal)] = r.status?.toLowerCase() ?? "";
    });

    return { tanggalList, siswaList, pivot };
  };

  const formatTglHeader = (tgl) => {
    const d  = new Date(tgl);
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    if (form.tipe === "harian") return `${dd}-${mm}-${d.getFullYear()}`;
    return `${dd}/${mm}`;
  };

  const statusColor  = { hadir:"text-green-600", sakit:"text-yellow-500", izin:"text-blue-500", alfa:"text-red-500" };
  const statusSymbol = { hadir:"✓", sakit:"S", izin:"I", alfa:"A" };

  const { tanggalList, siswaList, pivot } = buildPivot();

  return (
    <GuruLayout>
      <div className="space-y-6">

        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3">
          <div>
            <h1 className="text-2xl font-bold text-blue-600">Rekapitulasi Presensi</h1>
            <p className="text-xs md:text-sm text-slate-500">SMPN 1 Kamal</p>
          </div>
          <div className="flex gap-3 w-full md:w-auto">
            <button
              onClick={() => downloadFile("https://backend.smpn1kamal.sch.id/api/export-excel", "daftar-hadir.xlsx")}
              className="bg-green-500 text-white px-5 py-2.5 text-sm md:text-base rounded-full hover:bg-green-600 transition-all duration-300 shadow-md hover:scale-105 w-full md:w-auto"
            >
              Unduh Excel
            </button>
            <button
              onClick={() => downloadFile("https://backend.smpn1kamal.sch.id/api/export-pdf", "daftar-hadir.pdf")}
              className="bg-red-500 text-white px-5 py-2.5 text-sm md:text-base rounded-full hover:bg-red-600 transition-all duration-300 shadow-md hover:scale-105 w-full md:w-auto"
            >
              Unduh PDF
            </button>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow p-4 md:p-5">

          <div className="flex flex-col md:flex-row md:flex-wrap gap-3 md:items-center mb-4">
            <select value={form.id_mapel} onChange={(e) => setForm({ ...form, id_mapel: e.target.value })}
              className="border rounded-lg px-3 py-2 text-sm md:w-40">
              <option value="">Mapel</option>
              {mapelList.map((m) => <option key={m.id_mapel} value={m.id_mapel}>{m.nama_mapel}</option>)}
            </select>

            <select value={form.id_kelas} onChange={(e) => setForm({ ...form, id_kelas: e.target.value })}
              className="border rounded-lg px-3 py-2 text-sm md:w-40">
              <option value="">Kelas</option>
              {kelasList.map((k) => <option key={k.id_kelas} value={k.id_kelas}>{k.nama_kelas}</option>)}
            </select>

            <select value={form.tipe} onChange={(e) => setForm({ ...form, tipe: e.target.value })}
              className="border rounded-lg px-3 py-2 text-sm md:w-40">
              <option value="harian">Harian</option>
              <option value="range">Range</option>
              <option value="bulanan">Bulanan</option>
            </select>

            {form.tipe === "harian" && (
              <input type="date" value={form.tanggal}
                onChange={(e) => setForm({ ...form, tanggal: e.target.value })}
                className="border rounded-lg px-3 py-2 text-sm md:w-44" />
            )}
            {form.tipe === "range" && (
              <>
                <input type="date" value={form.start}
                  onChange={(e) => setForm({ ...form, start: e.target.value })}
                  className="border rounded-lg px-3 py-2 text-sm md:w-44" />
                <input type="date" value={form.end}
                  onChange={(e) => setForm({ ...form, end: e.target.value })}
                  className="border rounded-lg px-3 py-2 text-sm md:w-44" />
              </>
            )}
            {form.tipe === "bulanan" && (
              <input type="month" value={form.bulan}
                onChange={(e) => setForm({ ...form, bulan: e.target.value })}
                className="border rounded-lg px-3 py-2 text-sm md:w-44" />
            )}

            <button onClick={loadData}
              className="bg-indigo-500 text-white px-5 py-2 rounded-full hover:bg-indigo-600 text-sm md:ml-auto transition-all duration-300 shadow-md hover:scale-105">
              {loading ? "Loading..." : "Tampilkan"}
            </button>
          </div>

          <div className="hidden md:block overflow-x-auto">
            {data.length === 0 ? (
              <p className="text-center py-6 text-gray-500">Tidak ada data</p>
            ) : (
              <table className="w-full text-sm border-collapse">
                <thead className="bg-gray-50 text-gray-600 text-xs">
                  <tr>
                    <th className="border px-2 py-2 text-center bg-blue-50" rowSpan={2}>No</th>
                    <th className="border px-2 py-2 text-center bg-blue-50" rowSpan={2}>NISN</th>
                    <th className="border px-2 py-2 text-left bg-blue-50"   rowSpan={2}>Nama Siswa</th>
                    {tanggalList.length > 0 && (
                      <th className="border px-2 py-1 text-center bg-blue-50" colSpan={tanggalList.length}>
                        Pertemuan
                      </th>
                    )}
                    <th className="border px-2 py-1 text-center bg-orange-50" colSpan={5}>
                      Keterangan / Presentase
                    </th>
                  </tr>
                  <tr>
                    {tanggalList.map((tgl, i) => (
                      <th key={tgl} className="border px-1 py-1 text-center bg-blue-50 whitespace-nowrap">
                        <div className="text-gray-500">{i + 1}</div>
                        <div className="text-gray-400 font-normal">{formatTglHeader(tgl)}</div>
                      </th>
                    ))}
                    {["H","I","A","S","%"].map((lbl) => (
                      <th key={lbl} className="border px-2 py-1 text-center bg-orange-50">{lbl}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {siswaList.map((s, idx) => {
                    let jH=0, jI=0, jA=0, jS=0;
                    tanggalList.forEach((tgl) => {
                      const st = pivot[s.no_absen]?.[tgl] ?? "";
                      if (st === "hadir") jH++;
                      else if (st === "izin")  jI++;
                      else if (st === "alfa")  jA++;
                      else if (st === "sakit") jS++;
                    });
                    const total  = jH + jI + jA + jS;
                    const persen = total > 0 ? ((jH / total) * 100).toFixed(1) + "%" : "-";
                    return (
                      <tr key={s.no_absen} className="border-t hover:bg-gray-50">
                        <td className="border px-2 py-2 text-center">{idx + 1}</td>
                        <td className="border px-2 py-2 text-center text-xs">{s.nisn || "-"}</td>
                        <td className="border px-2 py-2">{s.nama_lengkap}</td>
                        {tanggalList.map((tgl) => {
                          const st = pivot[s.no_absen]?.[tgl] ?? "";
                          return (
                            <td key={tgl} className={`border px-1 py-2 text-center font-semibold ${statusColor[st] ?? "text-gray-300"}`}>
                              {statusSymbol[st] ?? ""}
                            </td>
                          );
                        })}
                        <td className="border px-2 py-2 text-center text-green-600 font-semibold">{jH}</td>
                        <td className="border px-2 py-2 text-center text-blue-500  font-semibold">{jI}</td>
                        <td className="border px-2 py-2 text-center text-red-500   font-semibold">{jA}</td>
                        <td className="border px-2 py-2 text-center text-yellow-500 font-semibold">{jS}</td>
                        <td className="border px-2 py-2 text-center text-gray-700  font-medium">{persen}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>

          <div className="md:hidden space-y-3">
            {data.length === 0 ? (
              <p className="text-center py-4 text-gray-500">Tidak ada data</p>
            ) : (
              siswaList.map((s) => {
                let jH=0, jI=0, jA=0, jS=0;
                tanggalList.forEach((tgl) => {
                  const st = pivot[s.no_absen]?.[tgl] ?? "";
                  if (st === "hadir") jH++;
                  else if (st === "izin")  jI++;
                  else if (st === "alfa")  jA++;
                  else if (st === "sakit") jS++;
                });
                const total  = jH + jI + jA + jS;
                const persen = total > 0 ? ((jH / total) * 100).toFixed(1) + "%" : "-";
                return (
                  <div key={s.no_absen} className="border rounded-lg p-3 shadow-sm">
                    <p className="font-semibold text-sm">{s.nama_lengkap}</p>
                    <p className="text-xs text-gray-500">NISN: {s.nisn || "-"}</p>
                    <p className="text-xs text-gray-500">No Absen: {s.no_absen}</p>
                    <div className="flex gap-3 mt-1 text-xs flex-wrap">
                      <span className="text-green-600 font-semibold">H: {jH}</span>
                      <span className="text-blue-500  font-semibold">I: {jI}</span>
                      <span className="text-red-500   font-semibold">A: {jA}</span>
                      <span className="text-yellow-500 font-semibold">S: {jS}</span>
                      <span className="text-gray-700  font-medium">Hadir: {persen}</span>
                    </div>
                  </div>
                );
              })
            )}
          </div>

        </div>
      </div>
    </GuruLayout>
  );
}